<template>
  <div>
    <div class="bannerList1">
      <el-carousel  height="355px" class="el-carousel bannerImgs" 
      v-if="bannerData&&bannerData[18]" 
      :indicator-position="(bannerData[18].list.length>1?'':'none')" :autoplay="true" arrow="never" :interval="8000">
        <el-carousel-item v-for="(item,index) in bannerData[18].list" :key="index">
          <img :src="item.url" @click="goRouter(item)"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <p class="news_r_tit">
      <span @click="goXF">徐州发布</span>
      <img src="http://hfy-img.xzyunchuang.com/01f8165ab7c2d34a3c57a9e9417d8384" />
    </p>
    <div v-if="otherData&&otherData.xuzhouNews&&otherData.xuzhouNews.length>0" class="fabu">
      <div class="newsList" @click="goFabu(item)" v-for="(item, index) in otherData.xuzhouNews.slice(0,5)" :key="index">
        <img :src="item.imgUrl" />
        <div>
          <p class="overf">{{ item.title }}</p>
          <p>{{ item.publishDate }}</p>
        </div>
      
      </div>
    </div>
    <div v-else>
      <div class="newsList" @click="goXzFb(item.jumpLink)" v-for="(item, index) in xuzhouNews" :key="index">
        <img :src="item.imgUrl" />
        <div>
          <p class="overf">{{ item.title }}</p>
          <p>{{ item.publishDate }}</p>
        </div>
      </div>
    </div>
    <p class="news_r_tit">
      <span @click="goNews()">最新资讯</span>
      <img src="http://hfy-img.xzyunchuang.com/01f8165ab7c2d34a3c57a9e9417d8384" />
    </p>

    <el-carousel v-if="otherData.latestNews&&otherData.latestNews.length>0" class="new_c" arrow="always">
      <el-carousel-item v-for="(item, index) in otherData.latestNews" :key="index">
        <div class="cordG new_Item" @click="goDetailNew(item)">
          <img :src="item.imgUrl" />
          <p class="overf">{{ item.title }}</p>
          <span v-if="item.publishDate">{{ item.publishDate}}</span>
        </div>
      </el-carousel-item>
    </el-carousel>
    <p class="news_r_tit">
      <span @click="goTopicList()">专题推荐</span>
      <img src="http://hfy-img.xzyunchuang.com/01f8165ab7c2d34a3c57a9e9417d8384" />
    </p>
    <div class="fabu">
      <div class="newsList" @click="goTopic(item)" v-for="(item, index) in otherData.recommendTopics" :key="index">
        <img :src="item.listUrl" />
        <div>
          <p class="overf" >{{ item.specialName }}</p>
          <span>{{ item.updateTime }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  otherNews
} from "@/api/news.js";
export default {
  name: 'contactUs',
  props: {
    bannerData: {
      type: [Array, Object],
      default: 0
    }
},
  
  data() {
    return {
      xuzhouNews:[
        {
          imgUrl:'http://www.xuzhoufabu.com//UpLoadFiles/image/20231109/20231109153164166416.jpg',
          title:'国家税务总局徐州市税务..',
          publishDate:'2023-11-09',
          jumpLink:'http://www.xuzhoufabu.com/html/2023/202311099502.shtml'
        },
        {
          imgUrl:'http://www.xuzhoufabu.com//UpLoadFiles/image/20231102/20231102105716051605.jpg',
          title:'“乐享湖山 快哉徐州”..',
          publishDate:'2023-11-02',
          jumpLink:'http://www.xuzhoufabu.com/html/2023/202311029499.shtml'
        },
        {
          imgUrl:'http://www.xuzhoufabu.com//UpLoadFiles/image/20231024/20231024115218891889.jpg',
          title:'徐州市实施慈善助医助困..',
          publishDate:'2023-10-24',
          jumpLink:'http://www.xuzhoufabu.com/html/2023/202310249496.shtml'
        },
        {
          imgUrl:'http://www.xuzhoufabu.com//UpLoadFiles/image/20231012/20231012112978107810.jpg',
          title:'无废城市”建设情况新..',
          publishDate:'2023-10-12',
          jumpLink:'http://www.xuzhoufabu.com/html/2023/202310129493.shtml'
        },
      ],
      otherData:{},
      botInfo: {},
    }
  },
  mounted() {
    this.otherNews();
  },
  methods: {
    goFabu(item){
      window.open('https://www.xuzhoufabu.com/videoDetail?id='+item.id, "_blank");
    },
    goTopicList(){
      window.open('/topic?tab=11', "_blank");  
    },
    goNews(){
      window.open('/importNews?id=1' +'&tab=1', "_self");
    },
    goXF(){
      window.open('https://www.xuzhoufabu.com', "_blank");
    },
    goTopic(item){
      if (item.module) {
                window.open('/topList?topic=' + item.id, "_blank");
            } else {
                window.open('/topList1?topic=' + JSON.stringify({topic:item.id}), "_blank");
            }
    },
    goRouter(item,index){
      
       // "type": 0,//跳转类型（1外链2文章3专题）
      // "relateId": "",//跳转类型1时为外链地址，2为文章id，3为专题id）
      if(item.type==1&&item.relateId){
        window.open(item.relateId,"_blank")
      }
      else if(item.type==2){
        window.open('/newsDetail?DetailId=' + item.relateId, "_blank");
      }
      else if(item.type==3){
         if(index){
           window.open('/spacilPage1', "_blank");
           return;
         }
         if (item.module) {
                window.open('/topList?topic=' + item.relateId, "_blank");
            } else {
                window.open('/topList1?topic=' + JSON.stringify({topic:item.relateId}), "_blank");
            }
      }
    },
    otherNews(){
       otherNews({}).then(res => {
          this.otherData=res.data;
       })
       
    },
    goXzFb(jumpLink){
      window.open(jumpLink, "_blank");
    },
    goDetailNew(item){
      if(item.articleType==1){
        window.open('/newsDetail?DetailId='+item.id, "_blank");
      }else{
        window.open(item.jumpLink, "_blank");
      }
      
    },
    // goRouter(d) {
    //   window.open(d, "_blank");
    //   // window.location.href=d;
    // }

  }
}
</script>
<style scoped lang="scss">
 /deep/.bannerImgs{
 width: 320PX;
  height: 355px;
  overflow: hidden;
  .el-carousel__container{
    height:  355px;
  }
  img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}
img {
  max-width: 100%;
}

.newsList {
  background: #F9F9F9;
}

// 最新咨询
/deep/ .new_c {
  height: 230px;
  overflow: hidden;
  .el-carousel__arrow {
    top: 92px !important;
  }
  .el-carousel__indicators--horizontal{
    bottom: 70px;
    .el-carousel__indicator--horizontal{
        padding: 6px 4px !important;
        .el-carousel__button{
          width: 6px;
          height: 6px;
          border-radius: 50%;
          opacity: 1;
          background: rgba($color: #fff, $alpha: 0.5);
        } 
      }
      .is-active{
        .el-carousel__button{
          background: #E00001;
        }
      }
            
  }
  .new_Item {
    padding-bottom: 10px;

    p {
      padding: 10px 10px;
    }

    span {
      color: #979A9C;
      font-size: 12px;
      margin: 0 20px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tabRight.vue